import { HttpClient } from '@angular/common/http';
import { config } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NewsOverviewService = /** @class */ (function () {
    function NewsOverviewService(http) {
        this.http = http;
    }
    NewsOverviewService.prototype.getNews = function (data) {
        return this.http.post(config.api + "/NewsPreview/GetNewsPreviews", data);
    };
    NewsOverviewService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NewsOverviewService_Factory() { return new NewsOverviewService(i0.ɵɵinject(i1.HttpClient)); }, token: NewsOverviewService, providedIn: "root" });
    return NewsOverviewService;
}());
export { NewsOverviewService };
